<template>
  <transition name="fade">
    <div class="modal" v-show="showModal">
      <transition name="slide">
        <div class="modal-card" v-show="showModal">
          <span class="close-btn" @click="handleCancel">
            <i class="icon-delete"></i>
          </span>
          
          <uSection>
            <uTitle>{{title}}</uTitle>
            <slot></slot>
          </uSection>
          <uSection class="footer" v-if="showFooter">
            <slot name="footer">
              <uButton class="right-side button-blue" @click="handleOk">确定</uButton>
              <textButton :text="'取消'" class="right-side coat-10 cancel-btn"  @click="handleCancel"></textButton>
            </slot>
          </uSection>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  name: "modal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    onOk: {
      type: Function,
      default() {}
    },
    onCancel: {
      type: Function,
      default() {}
    }
  },
  methods: {
    handleOk() {
      this.onOk();
      this.handClose();
    },
    handleCancel() {
      this.onCancel();
      this.handClose();
    },
    handClose() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../docs/scss/variables";

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
}
.slide-enter .modal-card,
.slide-leave-to .modal-card {
  transform: translateY(100%);
}
</style>


// WEBPACK FOOTER //
// src/components/modal/modal.vue